import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from './useRedux';
import {
  alternarEstabelecimento,
} from '../armazenamento';
import type { Estabelecimento } from '../tipos';

/**
 * Hook para gerenciamento de estabelecimentos
 * Requisitos: 3.2, 3.6
 *
 * - Retorna estabelecimentoAtual e lista de estabelecimentos do Redux
 * - Implementa função trocarEstabelecimento que valida vínculo, limpa dados e persiste
 * - A limpeza de dados do painel é feita internamente pelo thunk alternarEstabelecimento
 */
export const useEstabelecimento = () => {
  const dispatch = useAppDispatch();
  const { estabelecimentos, estabelecimentoAtual, carregando, erro } = useAppSelector(
    (estado) => estado.estabelecimento
  );

  /**
   * Alterna para outro estabelecimento.
   * O thunk alternarEstabelecimento valida o vínculo, persiste no localStorage
   * e limpa os dados do painel de controle automaticamente.
   */
  const trocarEstabelecimento = useCallback(
    (idEstabelecimento: string) => {
      dispatch(alternarEstabelecimento(idEstabelecimento));
    },
    [dispatch]
  );

  /**
   * Busca um estabelecimento pelo ID na lista carregada.
   */
  const obterEstabelecimentoPorId = useCallback(
    (id: string): Estabelecimento | undefined => {
      return estabelecimentos.find((e) => e.id === id);
    },
    [estabelecimentos]
  );

  return {
    estabelecimentos,
    estabelecimentoAtual,
    carregando,
    erro,
    trocarEstabelecimento,
    obterEstabelecimentoPorId,
  };
};
